import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: '¿Estás seguro?',
    },
    [OrderMethod.Pickup]: '¿El cliente ya ha recogido el pedido?',
    [OrderMethod.OnSite]: '¿El cliente ya ha recogido el pedido?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: '¿El pedido ya ha sido entregado?',
      [DeliveryProvider.UberDrive]: '¿El conductor ya ha recogido el pedido?',
      [DeliveryProvider.FirstDelivery]: '¿El conductor ya ha recogido el pedido?',
      [DeliveryProvider.WoltDrive]: '¿El conductor ya ha recogido el pedido?',
    },
  },
  buttons: {
    cancel: 'No, cancelar',
    confirm: 'Sí',
  },
};
